import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-blog-posts-table',
  templateUrl: './blog-posts-table.component.html',
  styleUrls: ['./blog-posts-table.component.scss']
})
export class BlogPostsTableComponent implements OnInit {

  @Input('table-data') tableData: any[] = [];
  @Input('page') page: number = 1;
  @Output('action') action = new EventEmitter<any>();
  
  constructor() { }

  ngOnInit(): void {
  }

  onDeleteClick(data: any) {
    this.action.emit({
      isAddSloka: false,
      isEdit: false,
      isDelete: true,
      isView: false,
      data: data,
    });
  }

  onEditClick(data: any) {
    this.action.emit({
      isAddSloka: false,
      isEdit: true,
      isDelete: false,
      isView: false,
      data: data,
    });
  }

  onViewClick(data: any) {
    this.action.emit({
      isAddSloka: false,
      isEdit: false,
      isDelete: false,
      isView: true,
      data: data,
    });
  }

}
